<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="dispatchAdd">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">新增业务</p>
      <div></div>
    </div>
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="boxon">
          <van-field
            autocomplete="off"
            v-model="addForm.shipName"
            name="船名"
            label="船名"
            placeholder="请填写船名"
            required
            :rules="[{ required: true, message: '请填写船名' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.voyageNumbe"
            name="船次"
            label="船次"
            placeholder="请填写船次"
            required
            :rules="[{ required: true, message: '请填写船次' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.mmsi"
            name="mmsi"
            label="mmsi"
            placeholder="请填写mmsi"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.customer"
            name="客户名称"
            label="客户名称"
            placeholder="请填写客户名称"
            required
            readonly
            @click="showCus"
            :rules="[{ required: true, message: '请填写客户名称' }]"
            right-icon="arrow-down"
          />
          <!-- <van-field          autocomplete="off"
          v-model="addForm.port"
          name="北方港"
          label="北方港"
          placeholder="请填写北方港"
          required
          :rules="[{ required: true, message: '请填写北方港' }]"
        /> -->
          <van-field
            autocomplete="off"
            v-model="addForm.transitPort"
            name="中转港"
            label="中转港"
            placeholder="请填写中转港"
            required
            readonly
            @click="showPi"
            :rules="[{ required: true, message: '请填写中转港' }]"
            right-icon="arrow-down"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.shippingType"
            name="运输类型"
            label="运输类型"
            placeholder="请填写运输类型"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.origin"
            name="picker"
            label="始发港"
            placeholder="请填写始发港"
            required
            readonly
            @click="showPick('origin')"
            :rules="[{ required: true, message: '请填写始发港' }]"
            right-icon="arrow-down"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.liuxiang"
            name="picker"
            label="目的港"
            placeholder="请填写目的港"
            required
            readonly
            @click="showPick('liuxiang')"
            :rules="[{ required: true, message: '请填写目的港' }]"
            right-icon="arrow-down"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.coalVariety"
            name="煤种"
            label="煤种"
            placeholder="请填写煤种"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.staffGauge"
            name="水尺数/吨"
            label="水尺数/吨"
            placeholder="请填写水尺数/吨"
            required
            type="digit"
            :rules="[{ required: true, message: '请填写水尺数/吨' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.name"
            name="作业动态"
            label="作业动态"
            placeholder="请填写作业动态"
          />
          <van-field name="是否场地货" label="是否场地货">
            <template #input>
              <van-radio-group v-model="addForm.cdType" direction="horizontal">
                <van-radio name="1">是</van-radio>
                <van-radio name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- <van-field autocomplete="off" v-model="addForm.planTime" name="picker" label="计划月份" placeholder="请选择计划月份"
            readonly @click="planyue" :rules="[{ required: true, message: '请选择计划月份' }]" right-icon="arrow-down" /> -->
        </div>

        <div style="margin: 45px 25px 0">
          <van-button round block type="info" native-type="submit"
            >新增</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="请选择"
        visible-item-count="4"
        :columns="portList"
        @confirm="onConfirm"
        value-key="label"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup v-model="transf" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择中转港"
        visible-item-count="4"
        :columns="transferssList"
        @confirm="onConfirm1"
        value-key="name"
        @cancel="onCancel1"
      />
    </van-popup>
    <van-popup v-model="pandata" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择计划月份"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="panlick"
        @cancel="canceldata"
      />
    </van-popup>
    <van-popup v-model="customer" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择客户"
        visible-item-count="4"
        :columns="customerList"
        @confirm="onConfirm2"
        value-key="comp"
        @cancel="onCancel2"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  dispatchSavePlan,
  dispatchGetPort,
  dispatchGetCustomer,
  transferss,
} from "@/utils/network/interface";
export default {
  name: "dispatchAdd",
  components: {},
  props: {},
  data() {
    return {
      addForm: {
        coalVariety: "",
        customer: "",
        customerId: "",
        liuxiang: "",
        origin: "",
        // "planTime": this.formatter(),
        // "port": "",
        shipName: "",
        shippingType: "",
        staffGauge: 0,
        taskStatus: "",
        transitPort: "",
        voyageNumbe: "",
        mmsi: "",
        cdType: "0",
      },
      showUnit: false,
      transf: false,
      customer: false,
      pandata: false,
      portList: [],
      transferssList: [],
      customerList: [],
      type: "origin",
      minDate: new Date(2019, 0),
      maxDate: new Date(2050, 12),
      currentDate: new Date(),
    };
  },
  computed: {},
  watch: {},
  created() {
    this.dispatchGetPort();
    this.transferssfrom();
    this.dispatchGetCustomer();
  },
  mounted() {},
  methods: {
    // formatter(type, val) {
    //   if (type === 'year') {
    //     return `${val}年`;
    //   } else if (type === 'month') {
    //     return `${val}月`;
    //   }
    //   return val;
    // },

    onSubmit(values) {
      if (this.addForm.cdType == 0 && !this.addForm.mmsi) {
        this.$toast("请输入mmsi");
      } else {
        dispatchSavePlan(this.addForm).then((res) => {
          if (res.code === 200) {
            history.go(-1);
          } else {
          }
        });
      }
    },
    dispatchGetPort() {
      dispatchGetPort().then((res) => {
        console.log(res);
        res.data.map((c) => {
          let obj = {
            label: c.label,
            children: c.options,
          };
          this.portList.push(obj);
        });
      });
    },
    transferssfrom() {
      transferss().then((res) => {
        this.transferssList = res.data;
        //console.log(this.transferssList)
      });
    },

    dispatchGetCustomer() {
      dispatchGetCustomer().then((res) => {
        this.customerList = res.data;
        //console.log(this.customerList)
      });
    },

    showPick(type) {
      this.type = type;
      this.$nextTick(() => {
        this.showUnit = true;
      });
    },
    showPi() {
      this.transf = true;
    },

    showCus() {
      this.customer = true;
    },
    onConfirm(value, index) {
      this.addForm[this.type] = value[1];
      this.showUnit = false;
      this.type = "";
    },
    onCancel() {
      this.type = "";
      this.showUnit = false;
    },
    onConfirm1(vale) {
      console.log(vale.name);
      this.addForm.transitPort = vale.name;
      this.transf = false;
    },

    onConfirm2(vale, index) {
      console.log(this.customerList);
      this.addForm.customer = this.customerList[index].comp;
      this.addForm.customerId = this.customerList[index].id;
      this.customer = false;
    },
    onCancel1() {
      this.transf = false;
    },

    onCancel2() {
      this.customer = false;
    },
    onClickBack() {
      this.$router.go(-1);
    },
    // 计划月份
    planyue() {
      this.pandata = true;
    },
    panlick(time) {
      this.addForm.planTime = this.formatter(time);
      this.pandata = false;
      console.log(this.addForm.planTime);
    },
    canceldata() {
      this.pandata = false;
    },
    formatter(time) {
      let nowdata = time == null ? new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month;
      // if (date < 10) {
      //   nowtime += "0";
      // }
      // nowtime += date;

      return nowtime;
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchAdd {
  // padding: 10px;
  background-color: #eee;
  min-height: 100vh;

  .nav {
    display: flex;
    align-items: center;
    height: 45px;
    background-color: #44b1f9;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }

  .form {
    padding: 10px;

    .boxon {
      border-radius: 8px;
      overflow: hidden;
    }

    /deep/.van-icon-arrow-down {
      color: #44b1f9;
    }
  }
}
</style>
